import React from "react";
import { Box } from "app/components/common";
import MessageHits from "../SearchScreen/MessageHits";
import Hits from "../SearchScreen/Hits";
import { useDispatch, useSelector } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { selectSeeIdea } from "@microdoing/shared/services/idea/actions";
import { openConversationRequest } from "@microdoing/shared/services/message/actions";
import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";
import { onChangeSearch } from "@microdoing/shared/services/search/actions";
import {
  getSearchText,
  getSearchType,
} from "@microdoing/shared/services/search/selector";
import { getCoachId } from "@microdoing/shared/services/coaching/selectors";
import { getIsCoachingCampaign } from "@microdoing/shared/services/userCampaign/selectors";
import { connectSearchBox } from "react-instantsearch-native";

interface IProps {
  onFinish: () => void;
}

const SearchHits = ({ onFinish, ...props }: IProps) => {
  const userId = useSelector(getUserId);
  const coachId = useSelector(getCoachId);
  const isCoachingCampaign = useSelector(getIsCoachingCampaign);

  const dispatch = useDispatch();

  const navigateChat = user => {
    if (user._id === userId) {
      return "";
    }

    const { picture, firstName, lastName, _id } = user;
    dispatch(
      openConversationRequest({
        receivers: [
          {
            _id,
            name: `${firstName} ${lastName}`,
            picture: picture,
          },
        ],
      }),
    );
    dispatch(onChangeSearch(""));
    onFinish();
  };

  return (
    <Box flex={1} width="100%" justifyContent="center" alignItems="center">
      <MessageHits
        onPressResult={navigateChat}
        userId={userId}
        isCoachingCampaign={isCoachingCampaign}
        coachId={coachId}
      />
    </Box>
  );
};

export default connectSearchBox(SearchHits);
